// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Stak_walletAddress {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: flex-start;
    font-size: 16px;
    font-weight: 600;
    color: #000000;
}

.addres-stak {
    width: 120px;
}

/* Staking Fetch Styling */
.fetch-stake-head {
    font-size: 30px;
    font-weight: 600;
}

.stakign-fetch-cont {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 500px;
}

.sfc-sec-cont {
    display: flex;
    justify-content: space-evenly;
    align-items: flex-start;
    flex-direction: column;
    width: 70%;
    height: 60%;
    background: linear-gradient(90deg, #fff, #fff);
    border: 1px solid #FFFFFF;
    box-shadow: -6px 10px 40px #00000014;
    border-radius: 10px;
    padding: 10px 20px;
}

.sfc-input-cont {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 30px;
    width: 100%;
    height: 50%;
}

.sfcic-sec {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.sfcic-sec input {
    border: 1px solid #234b9a;
    background: #eaf4fe;
    height: 45px;
    width: 90%;
    outline: none;
    border-radius: 4px;
    padding: 8.5px 12px;
    font-size: 16px;
    font-weight: 500;
    color: #000000;
}

.sfc-btn {
    background: #e84427;
    border: none;
    border-radius: 10px;
    outline: none;
    padding: 7px 20px;
    font-size: 20px;
    font-weight: 600;
    width: 50%;
    height: 45px;
    color: white;
}

.sfc-btn:hover {
    background: #e84427e5;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Staking/Staking.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA,0BAA0B;AAC1B;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,uBAAuB;IACvB,sBAAsB;IACtB,UAAU;IACV,WAAW;IACX,8CAA8C;IAC9C,yBAAyB;IACzB,oCAAoC;IACpC,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":[".Stak_walletAddress {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    justify-content: flex-start;\n    font-size: 16px;\n    font-weight: 600;\n    color: #000000;\n}\n\n.addres-stak {\n    width: 120px;\n}\n\n/* Staking Fetch Styling */\n.fetch-stake-head {\n    font-size: 30px;\n    font-weight: 600;\n}\n\n.stakign-fetch-cont {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 500px;\n}\n\n.sfc-sec-cont {\n    display: flex;\n    justify-content: space-evenly;\n    align-items: flex-start;\n    flex-direction: column;\n    width: 70%;\n    height: 60%;\n    background: linear-gradient(90deg, #fff, #fff);\n    border: 1px solid #FFFFFF;\n    box-shadow: -6px 10px 40px #00000014;\n    border-radius: 10px;\n    padding: 10px 20px;\n}\n\n.sfc-input-cont {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    gap: 30px;\n    width: 100%;\n    height: 50%;\n}\n\n.sfcic-sec {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.sfcic-sec input {\n    border: 1px solid #234b9a;\n    background: #eaf4fe;\n    height: 45px;\n    width: 90%;\n    outline: none;\n    border-radius: 4px;\n    padding: 8.5px 12px;\n    font-size: 16px;\n    font-weight: 500;\n    color: #000000;\n}\n\n.sfc-btn {\n    background: #e84427;\n    border: none;\n    border-radius: 10px;\n    outline: none;\n    padding: 7px 20px;\n    font-size: 20px;\n    font-weight: 600;\n    width: 50%;\n    height: 45px;\n    color: white;\n}\n\n.sfc-btn:hover {\n    background: #e84427e5;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
